import React from 'react';
import { Grid, Card, CardContent, Typography, useTheme } from '@mui/material';
import InsightCard from './InsightCard';
import PropTypes from 'prop-types';

/**
 * InsightSection Component
 * Reusable section component for displaying a grid of insight cards
 */
const InsightSection = ({ title, insights, type }) => {
  const theme = useTheme();

  if (!insights || insights.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} sx={{ display: 'flex' }}>
      <Card
        sx={{
          borderRadius: '10px',
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: 'none',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CardContent
          sx={{
            p: 2.5,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
              mb: 2,
              fontSize: '0.9375rem',
              letterSpacing: '-0.01em',
            }}
          >
            {title}
          </Typography>
          <Grid
            container
            spacing={2}
            sx={{
              alignItems: 'stretch',
              width: '100%',
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: 'repeat(2, 1fr)',
              },
              gap: 2,
              '& > .MuiGrid-item': {
                display: 'flex',
                minHeight: '240px',
                width: '100%',
              },
            }}
          >
            {insights.map((insight, index) => (
              <Grid
                item
                xs={12}
                md={6}
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'stretch',
                  minWidth: 0,
                  width: '100%',
                }}
              >
                <InsightCard insight={insight} type={type} />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

InsightSection.propTypes = {
  title: PropTypes.string.isRequired,
  insights: PropTypes.array.isRequired,
  type: PropTypes.oneOf([
    'system_trend',
    'template_effectiveness',
    'error_trend',
    'anomaly',
  ]).isRequired,
};

export default InsightSection;
